import styled from 'styled-components';

import RunMetadata from '~/components/RunMetadata';

export const RunMetaData = styled(RunMetadata)`
  margin-top: 10px;
  height: 44px;
`;
